export default __webpack_public_path__ + "static/aimychat-logo-b29ceaa0c16673d01b7982624ba30a4e.svg";